export function IlustracaoFolha(props) {
  return (
    <svg
      width={28}
      height={34}
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 33.667a3.335 3.335 0 003.333-3.333v-20l-10-10H4A3.335 3.335 0 00.667 3.667v26.667A3.335 3.335 0 004 33.667h20zm-8.334-30L24 12.001h-8.333V3.667zm-10 6.667h5v3.333h-5v-3.333zm0 6.667h16.667v3.333H5.667v-3.333zm0 6.666h16.667v3.334H5.667v-3.334z"
        fill="#C8C8C8"
      />
    </svg>
  );
}
